module.exports = __webpack_public_path__ + "img/banner-1.e0760c3e.jpg";